/* eslint-disable */


import {} from "../mutationTypes";
import {FETCH_CART_REQUEST} from "../mutationTypes";
import ShoppingCartApi from "@shared/_api/shoppingCart";
import {FETCH_CART_SUCCESS} from "../mutationTypes";
import {FETCH_CART_FAILED} from "../mutationTypes";
import ContentAPI from "@shared/_api/cms/content";
import {UPDATE_CONTENT_SUCCESS} from "../admin/content/mutationTypes";
import {ADD_CART_ITEM_REQUEST} from "../mutationTypes";
import {ADD_CART_ITEM_SUCCESS} from "../mutationTypes";
import {ADD_CART_ITEM_FAILED} from "../mutationTypes";
import * as normalizr from "normalizr";
import {DELETE_CART_ITEM_SUCCESS} from "../mutationTypes";
import {DELETE_CART_ITEM_FAILED} from "../mutationTypes";
import {DELETE_CART_ITEM_REQUEST} from "../mutationTypes";
import {UPDATE_CART_ITEM_REQUEST} from "../mutationTypes";
import {UPDATE_CART_ITEM_SUCCESS} from "../mutationTypes";
import {UPDATE_CART_ITEM_FAILED} from "../mutationTypes";
import {FETCH_SAMPLE_SUCCESS} from "../mutationTypes";

const normalize = normalizr.normalize;
const schema = normalizr.schema;

const item = new schema.Entity('shoppingCartItemList');
const cartEntity = new schema.Entity('shoppingCartList');

item.define({
    cart : cartEntity
});


cartEntity.define({
    shoppingCartItemList: [item]
});

const state = {
    entities: {
        shoppingCartItemList: [],
        shoppingCartList: [],
    },
    loadingCart: false,
    busyItemId: null

};

const actions = {
    fetchCart({commit, rootState}) {
        if(rootState.account.user) {
            commit(FETCH_CART_REQUEST);
            return ShoppingCartApi.getList().then(cartList => {
                commit(FETCH_CART_SUCCESS, normalize(cartList, [cartEntity]));
                return cartList;
            }).catch(error => {
                console.log(error);
                commit(FETCH_CART_FAILED);
            })
        }
    },
    addItem({commit}, {cartItem}) {
        commit(ADD_CART_ITEM_REQUEST);

        return ShoppingCartApi.add(cartItem).then((cartList) => {
            commit(FETCH_CART_SUCCESS, normalize(cartList, [cartEntity]));
            return cartList;
        }).catch(error => {
            console.log(error);
            commit(FETCH_CART_FAILED);
        })
    },
    removeItem({commit}, {cart, item}) {
        commit(DELETE_CART_ITEM_REQUEST, item);
        return ShoppingCartApi.remove(item.id).then(() => {
            commit(DELETE_CART_ITEM_SUCCESS, {cart: cart, item: item})
        }).catch(error => {
            commit(DELETE_CART_ITEM_FAILED, item);
        })
    },
    updateItem({commit}, {item}) {
        commit(UPDATE_CART_ITEM_REQUEST, item);
        return ShoppingCartApi.update(item).then(() => {
            commit(UPDATE_CART_ITEM_SUCCESS, item)
        }).catch(error => {
            console.log(error);
            commit(UPDATE_CART_ITEM_FAILED);
        })
    },
};

const getters = {
    itemCount: (state) => state.entities.shoppingCartItemList ? Object.keys(state.entities.shoppingCartItemList).length : 0,
    cartArray: (state) => state.entities.shoppingCartList,
    itemArray: (state) => state.entities.shoppingCartItemList,
    cartById: (state => (cartId) => {
        return state.entities.shoppingCartList ? state.entities.shoppingCartList[cartId] : null;
    })
}

const mutations = {
    [FETCH_CART_SUCCESS](state, cartListNormalized) {
        Vue.set(state.entities, 'shoppingCartItemList', cartListNormalized.entities.shoppingCartItemList);
        Vue.set(state.entities, 'shoppingCartList', cartListNormalized.entities.shoppingCartList);
        state.loadingCart = false;
    },
    [FETCH_CART_REQUEST](state) {
        state.entities = {
            shoppingCartItemList: [],
            shoppingCartList: [],
        };
        state.loadingCart = true;
    },
    [FETCH_CART_FAILED](state) {
        state.loadingCart = false;
    },
    [ADD_CART_ITEM_REQUEST](state) {
        state.loadingCart = true;
    },
    [ADD_CART_ITEM_SUCCESS](state) {
        state.loadingCart = true;
    },
    [ADD_CART_ITEM_FAILED](state) {
        state.loadingCart = false;
    },
    [DELETE_CART_ITEM_REQUEST](state, item) {
        state.busyItemId = item.id;
    },
    [DELETE_CART_ITEM_SUCCESS](state, {cart, item}) {
        Vue.delete(state.entities.shoppingCartItemList, item.id);
        Vue.delete(state.entities.shoppingCartList[cart.id].shoppingCartItemList, state.entities.shoppingCartList[cart.id].shoppingCartItemList.indexOf(item.id));

        if(state.entities.shoppingCartList[cart.id].shoppingCartItemList.length === 0) {
            Vue.delete(state.entities.shoppingCartList, cart.id);
        }
    },
    [DELETE_CART_ITEM_FAILED](state, item) {
        state.busyItemId = null;
    },
    [UPDATE_CART_ITEM_REQUEST](state, item) {
        state.busyItemId = item.id;
    },
    [UPDATE_CART_ITEM_SUCCESS](state, item) {
        Vue.set(state.entities.shoppingCartItemList[item.id], item);
        state.busyItemId = null;
    },
    [UPDATE_CART_ITEM_FAILED](state, item) {
        state.busyItemId = null;
    }

};

export const cart = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};